<template>
  <div class="login-layout">
    <div style="margin: 0;" class="row login-container">
		<div class="logo"><i class="icon-tacot-logo"></i></div>
		<div style="width: 100%; max-width: 100%;"></div>
		<div class=""><child /></div>
	</div>
	
  </div>
</template>

<script>
export default {
  name: 'loginLayout'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/layouts/login.vue